import React from 'react';
import { FooterStyled } from './FooterStyled';
export function Footer(props) {
    const { children, isRightToLeft } = props;
    return React.createElement(FooterStyled, { isRightToLeft: isRightToLeft }, children);
}
